import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  fetchOperatorSummary,
  fetchOperatorComparison,
  fetchOperatorMaterial,
  fetchProductPerformance,
  fetchChangeoverSummary,
  fetchChangeoverByProduct,
  fetchOperatorMatrix,
  fetchMaterialMatrix,
  fetchOperatorTrend
} from '../api/productionMetricsApi.js';

export function useOperatorSummary(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'operator-summary', filters],
    queryFn: () => fetchOperatorSummary(filters),
    placeholderData: keepPreviousData
  });
}

export function useOperatorComparison(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'operator-comparison', filters],
    queryFn: () => fetchOperatorComparison(filters),
    placeholderData: keepPreviousData
  });
}

export function useOperatorMaterial(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'operator-material', filters],
    queryFn: () => fetchOperatorMaterial(filters),
    placeholderData: keepPreviousData
  });
}

export function useProductPerformance(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'product-performance', filters],
    queryFn: () => fetchProductPerformance(filters),
    placeholderData: keepPreviousData
  });
}

export function useChangeoverSummary(filters = {}) {
  return useQuery({
    queryKey: ['changeover-events', 'summary', filters],
    queryFn: () => fetchChangeoverSummary(filters),
    placeholderData: keepPreviousData
  });
}

export function useChangeoverByProduct(filters = {}) {
  return useQuery({
    queryKey: ['changeover-events', 'by-product', filters],
    queryFn: () => fetchChangeoverByProduct(filters),
    placeholderData: keepPreviousData
  });
}

export function useOperatorMatrix(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'operator-matrix', filters],
    queryFn: () => fetchOperatorMatrix(filters),
    placeholderData: keepPreviousData
  });
}

export function useMaterialMatrix(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'material-matrix', filters],
    queryFn: () => fetchMaterialMatrix(filters),
    placeholderData: keepPreviousData
  });
}

export function useOperatorTrend(filters = {}) {
  return useQuery({
    queryKey: ['production-metrics', 'operator-trend', filters],
    queryFn: () => fetchOperatorTrend(filters),
    placeholderData: keepPreviousData
  });
}
